import { useMemo } from "react";
import { trpc } from "@/lib/trpc";

/**
 * A primeira transação é o marco persistente de ativação do produto.
 * Enquanto ela não existe, recursos secundários permanecem discretos.
 */
export function useFirstTransaction() {
  const input = useMemo(() => ({ limit: 1, offset: 0 }), []);
  const query = trpc.transactions.list.useQuery(input, {
    staleTime: 60 * 1000,
  });

  return {
    hasFirstTransaction: (query.data?.length ?? 0) > 0,
    isLoading: query.isLoading,
  };
}
